import React from 'react';

const EnvironmentalSocialGovernance = React.lazy(() => import('../page/esg/EnvironmentalSocialGovernance'));
const EnvironmentalSocialGovernanceHistory = React.lazy(() => import('../page/esg/EnvironmentalSocialGovernanceHistory'));
const EnvironmentalSocialGovernanceHome = React.lazy(() => import('../page/esg/EnvironmentalSocialGovernanceHome'));
const EnvironmentalSocialGovernanceStart = React.lazy(() => import('../page/esg/EnvironmentalSocialGovernanceStart'));

const routerConfig = [
	{
		path: '/esgHome',
		component: EnvironmentalSocialGovernanceHome,
		intl: async () => { 
			const intl = await import('../i18n/environmentalsocialgovernance'); 
			return intl; 
		},
		redux: {
			key: 'environmentalSocialGovernanceHome',
			reducer: async () => { 
				const rdc = await import('../redux/esgReducer'); 
				return rdc; 
			}
		}
	},
	{
		path: '/esg',
		component: EnvironmentalSocialGovernance,
		intl: async () => { 
			const intl = await import('../i18n/environmentalsocialgovernance'); 
			return intl; 
		},
		redux: {
			key: 'environmentalSocialGovernance',
			reducer: async () => { 
				const rdc = await import('../redux/esgReducer'); 
				return rdc; 
			}
		}
	},
	{
		path: '/esgHistory',
		component: EnvironmentalSocialGovernanceHistory,
		intl: async () => { 
			const intl = await import('../i18n/environmentalsocialgovernance'); 
			return intl; 
		},
		redux: {
			key: 'environmentalSocialGovernanceHistory',
			reducer: async () => { const rdc = await import('../redux/esgReducer'); return rdc; }
		}
	},
	{
		path: '/esgStart',
		component: EnvironmentalSocialGovernanceStart,
		intl: async () => { 
			const intl = await import('../i18n/environmentalsocialgovernance'); 
			return intl; 
		}
		// redux: {
		// 	key: 'environmentalSocialGovernanceStart',
		// 	reducer: async () => { const rdc = await import('../redux/esgReducer'); return rdc; }
		// }
	}
	// {
	// 	path: '/lccHome',
	// 	component: LegacyClientConsentHome,
	// 	intl: async () => { const intl = await import('../i18n/legacyclientconsent'); return intl; },
	// 	redux: {
	// 		key: 'legacyClientConsentHome',
	// 		reducer: async () => { const rdc = await import('../redux/lccReducer'); return rdc; }
	// 	}
	// },
	// {
	// 	path: '/lcc',
	// 	component: LegacyClientConsent,
	// 	intl: async () => { const intl = await import('../i18n/legacyclientconsent'); return intl; },
	// 	redux: {
	// 		key: 'legacyClientConsent',
	// 		reducer: async () => { const rdc = await import('../redux/lccReducer'); return rdc; }
	// 	}
	// },
	// {
	// 	path: '/lccHistory',
	// 	component: LegacyClientConsentHistory,
	// 	intl: async () => { const intl = await import('../i18n/legacyclientconsent'); return intl; },
	// 	redux: {
	// 		key: 'legacyClientConsentHistory',
	// 		reducer: async () => { const rdc = await import('../redux/lccReducer'); return rdc; }
	// 	}
	// }

];

export default routerConfig;
